module.exports = __webpack_public_path__ + "static/img/fayuan-icon9.cdd8b084.png";